<template>
  <div>
    <div class="title-bar-container flex"
         :style="areaStyle"
    >
      <div class="bar-title-box flex-box">
        <div class="bar-title" :style="titleStyle">{{titleContentData.titleName}}</div>
        <div class="bar-summary"
             :style="summaryStyle"
        >
          {{titleContentData.titleDes}}
        </div>
      </div>
      <a @click="jumpUrl(titleContentData)"
         :style="alinkStyle"
         :class="['bar-link',{'pos_abs': titleStyle.textAlign == 'center'}]"
      >
        {{titleContentData.titleUrl}}
      </a>
    </div>
  </div>
</template>
<script>
import {checkMoreClickFn} from './clickJs'
export default {
  name: "titleBar",
  data() {
    const { tempData: { specialData, specialStyle, titleContentData}, terminal } = this.data
    return {
      specialData,
      specialStyle,
      titleContentData,
      terminal,
    }
  },
  props: {
    data: {
      type: Object
    },
  },
  computed: {
    areaStyle(){
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor
      } =  this.specialStyle;
      return {
        marginTop: `${blockMargeTop}px`,
        marginBottom: `${blockMargeBottom}px`,
        backgroundColor: blockBGClolor?blockBGClolor:'none',
      }
    },
    titleStyle(){
      const {
        titleSize,
        titleColor='#333',
        titleBold=false,
        titleAlign
      } =  this.specialStyle;
      return {
        fontSize: `${titleSize?titleSize:18}px`,
        color: titleColor,
        fontWeight: `${titleBold?'bold':''}`,
        textAlign: titleAlign?titleAlign:'center',
      }
    },
    alinkStyle(){
      const {
        titleSize,
      } =  this.specialStyle;
      return {
        height: `${(titleSize ? titleSize : 18) * 1.4}px`,
        lineHeight: `${(titleSize ? titleSize : 18) * 1.4}px`
      }
    },
    summaryStyle(){
      const {
        descSize,
        descColor,
        descBold=false,
        descAlign
      } =  this.specialStyle;
      return {
        fontSize: `${descSize?descSize:12}px`,
        color: descColor?descColor:'#666',
        fontWeight: `${descBold?'bold':''}`,
        textAlign: descAlign?descAlign:'center',
      }
    }
  },
  methods: {
    //跳转
    jumpUrl(item){
      checkMoreClickFn(item,this.specialData,this,true)
    },
  }
};
</script>
<style lang="less" scoped>
.title-bar-container{
  padding: 24px;
  line-height: 1.44;
  box-sizing: border-box;
  &.flex{
    display: flex;
  }
  .bar-link{
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    margin-left: 24px;
    line-height: 2;
    word-break: break-all;
  }
  .bar-title{
    word-break: break-all;
  }
  .bar-summary{
    margin-top: 12px;
    word-break: break-all;
  }
  .flex-box{
    flex: 1;
  }
  .pos_abs{
    position: absolute;
    right: 24px;
  }
}

</style>
